import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

function OratoriaRedirect() {
  window.location.replace("/oratoria/index.html");
  return null;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oratoria",
    element: <OratoriaRedirect />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
